exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".receiptButton {\r\n  cursor: pointer;\r\n}\r\n\r\n.mat-dialog-container {\r\n  height:100%;\r\n}\r\n\r\n.mat-dialog-content {\r\n  height:100%;\r\n  max-height: none !important;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/payment-history/payment-history.component.css
// module id = ../../../../../src/app/component/payment-history/payment-history.component.css
// module chunks = main